import autobind from "autobind-decorator";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Form } from "react-bootstrap";
import type { FieldRenderProps } from "react-final-form";
import type { FormItemProps } from "./FormItem";
import { FormItem } from "./FormItem";

export interface FormDecidableProps extends FormItemProps<boolean> {
	trueTitle?: ReactNode;
	falseTitle?: ReactNode;
	nonCentered?: boolean;
	twoLine?: boolean;
}

export class FormDecidable extends FormItem<boolean, FormDecidableProps> {
	public static defaultProps: Partial<FormDecidableProps> = {
		trueTitle: "Igen",
		falseTitle: "Nem",
	};

	protected renderField(fieldProps: FieldRenderProps<boolean>): ReactNode {
		const { name, value, onChange: _1, type: _2, checked: _3, ...props } = fieldProps.input;
		const {
			trueTitle,
			falseTitle,
			disabled,
			tabIndex,
			readOnly,
			nonCentered = false,
			twoLine = false,
		} = this.props;

		return (
			<div className={compact([!twoLine && "d-flex", !nonCentered && "justify-content-around"]).join(" ")}>
				<div className="mx-2">
					<Form.Check
						custom
						type="radio"
						name={name}
						id={`${name}-true-${this.id}`}
						tabIndex={tabIndex}
						readOnly={readOnly}
						value="true"
						label={trueTitle}
						disabled={disabled || readOnly}
						checked={(value as any) === true}
						onChange={() => this.handleChange(true, fieldProps)}
						onBlur={(event) => this.handleBlur(event, fieldProps)}
						{...props}
					/>
				</div>
				<div className="mx-2">
					<Form.Check
						custom
						type="radio"
						name={name}
						id={`${name}-false-${this.id}`}
						value="false"
						tabIndex={tabIndex}
						readOnly={readOnly}
						label={falseTitle}
						disabled={disabled || readOnly}
						checked={(value as any) === false}
						onChange={() => this.handleChange(false, fieldProps)}
						onBlur={(event) => this.handleBlur(event, fieldProps)}
						{...props}
					/>
				</div>
			</div>
		);
	}

	protected format(value: string): boolean {
		if (value === "true") {
			return true;
		}

		if (value === "false") {
			return false;
		}

		if (value !== undefined) {
			return !!value;
		}
	}

	@autobind
	protected handleValidate(value: boolean, allValues: Record<string, any>): string {
		const { required = false } = this.props;

		if (this.isDisabled()) {
			return undefined;
		}

		if (required && value === undefined) {
			return "Válassz ki egy elemet!";
		}

		return super.handleValidate(value, allValues);
	}
}
